/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Profile_Discord_ErrorInputs */



/**
* | output |
* | --- |
* | "Discord linking error: {error}" |
*
* @param {Profile_Discord_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_discord_error = /** @type {((inputs: Profile_Discord_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Discord_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur de liaison Discord : ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al vincular Discord: ${i?.error}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Erro ao vincular Discord: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore collegamento Discord: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Discord linking error: ${i?.error}`)
});